import { useContext } from 'react'
import { ClientPreferencesContext } from './clientPreferencesContextCore'

export const useClientPreferences = () => {
  const context = useContext(ClientPreferencesContext)
  if (!context) throw new Error('useClientPreferences must be used within ClientPreferencesProvider')
  return context
}
